import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";

function Form() {
    const profileFilter = chooseProfileFilter();
    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    let informateGeoCoordinates = false;

    const endpointBackend = config.endpoints.backend;
    const path = 'governanceroom/neighborhoods';

    const paths = {
        endpointSave: `${endpointBackend}governanceroom/neighborhoods/save`,
        endpointGetById: `${endpointBackend}${path}/getById`,
        urlGoBack: `/governanceroom/neighborhoods/list`,
        pathView: `/governanceroom/neighborhoods/view`
    }

    const labels = {
        labelTitleAdd: "Novo Bairro",
        labelTitleEdit: "Editar Bairro",
        labelTitleView: 'Visualizar Bairro'
    }

    const hiddenValues = {}

    if (profileFilter.core_application_instance_id) {
        hiddenValues.core_application_instance_id = profileFilter.core_application_instance_id
    }

    const getForm = (values) => {

        let form = {
            hiddenValues: hiddenValues,
            fields: [
                {
                    name: 'geografic_state_id',
                    type: 'select',
                    label: 'Estado',
                    options: [],
                    optionsEndpoint: {
                        endpoint: endpointBackend + 'governanceroom/states/getall',
                        label: 'geografic_state_name',
                        value: 'geografic_state_id',
                        params: {
                            filter: {
                                where: {
                                    profileFilter
                                }
                            }
                        }
                    },
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        values.governance_room_group_id = '';
                        values.governance_room_geo_city_id = '';
                        values.governance_room_sub_group_id = '';
                        setForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'governance_room_geo_city_id',
                    type: 'select',
                    label: 'Município',
                    options: [],
                    optionsEndpoint: {
                        endpoint: endpointBackend + 'governanceroom/cities/getall',
                        label: 'city_name',
                        value: 'id',
                        params: {
                            filter: {
                                where: {
                                    profileFilter,
                                    geografic_state_id: values.geografic_state_id
                                },
                            }
                        }
                    },
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        values.governance_room_group_id = '';
                        values.governance_room_sub_group_id = '';
                        setForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'governance_room_group_id',
                    type: 'select',
                    label: 'Grupo',
                    options: [],
                    optionsEndpoint: {
                        endpoint: endpointBackend + 'governanceroom/groups/getall',
                        label: 'group_name',
                        value: 'id',
                        params: {
                            filter: {
                                profileFilter,
                                governance_room_city_id: values.governance_room_geo_city_id,
                                geografic_state_id: values.geografic_state_id
                            }
                        }
                    },
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        values.governance_room_sub_group_id = '';
                        setForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'governance_room_sub_group_id',
                    type: 'select',
                    label: 'Sub-Grupo',
                    options: [],
                    optionsEndpoint: {
                        endpoint: endpointBackend + 'governanceroom/subgroups/getall',
                        label: 'description',
                        value: 'id',
                        params: {
                            filter: {
                                profileFilter,
                                governance_room_city_id: values.governance_room_geo_city_id,
                                geografic_state_id: values.geografic_state_id,
                                governance_room_group_id: values.governance_room_group_id
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'description',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'inform_geo_coordinates',
                    type: 'checkbox',
                    switch: true,
                    label: 'Informar coordenadas geográficas',
                    validations: {
                        required: false
                    },
                    handleChange: async (element, field, values) => {
                        informateGeoCoordinates = values.inform_geo_coordinates === '1';
                        let form = getForm(values);
                        setForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 12
                },
                !informateGeoCoordinates && {
                    name: 'address',
                    type: 'address',
                    label: 'Endereço',
                    autocomplete: true,
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                informateGeoCoordinates && {
                    name: 'lat',
                    type: 'text',
                    label: 'Latitude',
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                informateGeoCoordinates && {
                    name: 'lng',
                    type: 'text',
                    label: 'Longitude',
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },

            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            if (profileFilter.core_application_instance_id) {
                values.core_application_instance_id = profileFilter.core_application_instance_id;
            }
            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
